import { render } from "./yearlyGrowth.vue?vue&type=template&id=4ae52a10"
import script from "./yearlyGrowth.vue?vue&type=script&lang=js"
export * from "./yearlyGrowth.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__